export default __webpack_public_path__ + "static/media/follow-monstv.0bf30cba.webp";